import React, { Component } from "react";
import "./HomeTourModal.css";
import {injectIntl} from "react-intl";
import GirlTour from "../../../assets/images/girl_tour.png";
import ExploreStep3Img from "../../../assets/images/explore-step3-img.png";

export class ExploreStep3 extends Component {

    render(){

        return (
            <React.Fragment>
                <div className="e-t-container step2 step4">
                    <div className="e-t-imgcont step2">
                        <img src={GirlTour} alt="girl" className="e-t-img-girl-step2"/>
                    </div>
                    <div className="e-t-texts step2">
                        <img src={ExploreStep3Img} alt="girl" className="e-t-img-step2"/>
                        <p className="e-t-subtitle step3">
                            En esta opción puedes editar y configurar tu cuenta o invitar a alguna persona más
                        </p>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default injectIntl(ExploreStep3);
